import React from 'react'
import { s, globals, colors, alpha } from '../../style'

const WrapperContainer = ({ children, theme, extraCss, fullMobile }) => {
  return (
    <div css={[sContainer, sTheme(theme), extraCss, fullMobile && sfullMobile]}>
      {children}
    </div>
  )
}

const sContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',

  [s.sm_down]: {
    boxShadow: globals.shadows.sections.mobile,
    marginLeft: globals.spacing.outside.mobile,
    marginRight: globals.spacing.outside.mobile,
    borderRadius: globals.roundness.sections.mobile,
    padding: globals.spacing.inside.mobile,
  },
  [s.sm_only]: {
    padding: globals.spacing.inside.mobile * 2,
  },
  [s.md]: {
    padding: globals.spacing.inside.desktop,
    boxShadow: globals.shadows.sections.desktop,
    margin: '0 auto',
    borderRadius: globals.roundness.sections.desktop,
  },
}

const sTheme = (theme) => ({
  background: `linear-gradient(to bottom right, ${colors[
    theme
  ].container.concat(alpha[90])}, ${colors[theme].container.concat(
    alpha[60]
  )})`,
})

const sfullMobile = {
  [s.xs]: {
    margin: 0,
  },
}

export default WrapperContainer
